<template>
    <div>
        <header class="header">
            <div class="container">
                <a href="/" class="header__logo">
                    <img src="img/logo-horizontal.png" alt="" />
                </a>

                <a href="/login" class="btn btn--md2 btn--primary miw--130 d-lg--none">Play now</a>

                <nav class="menu ml--auto d--none d-lg--flex">
                    <ul class="mb--0">
                        <li class="active"><router-link :to="'#introduction'">What is Quiz42?</router-link></li>
                        <li><router-link :to="'#individuals'">For individuals</router-link></li>
                        <li><router-link :to="'#teachers'">For teachers</router-link></li>
                        <li><router-link :to="'#students'">For students</router-link></li>
                        <li><router-link :to="'#groups'">For groups</router-link></li>
                    </ul>

                    <a href="/login" class="btn btn--md2 btn--primary miw--130">Play now</a>
                </nav>
            </div>
        </header>

        <nav class="menu d-lg--none">
            <ul class="mb--0">
                <li class="active"><a href="#introduction" data-scroll-to>Introduction</a></li>
                <li><a href="#individuals" data-scroll-to>For individuals</a></li>
                <li><a href="#teachers" data-scroll-to>For teachers</a></li>
                <li><a href="#students" data-scroll-to>For students</a></li>
                <li><a href="#groups" data-scroll-to>For groups</a></li>
            </ul>
        </nav>

        <section id="introduction" class="section bg--wave bg--wave-1 pb--0 pt--30">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-12 col-md-6 col-xl-5">
                        <h3 class="title-primary mb--sm" data-animate="fadeInUp"><span class="c--gradient-primary">What is Quiz42?</span></h3>
                        <h2 class="title-section" data-animate="fadeInUp">Play, learn, connect</h2>

                        <div data-animate="fadeInUp">
                            <div class="opacity--sm">
                                <p>Quiz42 (quiz-for-two) is a fun and exciting way to improve your English by playing against
                                    other learners and speakers all over the world.</p>

                                <p class="d--none d-md--block">You can practise in single player mode, or play against friends, classmates or random
                                    opponents in multiplayer. Create group and knock-out games, and connect with English speakers worldwide.</p>
                            </div>

                            <ul class="list--square mb--xl">
                                <li>4 different levels</li>
                                <li>20+ categories per level</li>
                                <li>13 000+ questions</li>
                            </ul>
                        </div>

                        <p class="mb--xl" data-animate="fadeInUp">
                            <a href="https://youtu.be/h7htZGUQnK8" data-fancybox class="btn btn--circle-icon">
                                <img src="img/icons/play.png" alt="" /> See how to play
                            </a>
                        </p>
                    </div>

                    <div class="col-12 col-lg-5 offset-lg-1 offset-xl-2" data-animate="fadeInUp">
                        <div class="swiper-container tile-carousel">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide col-md-3 col-lg-6 mb--30 pull-lg-top">
                                    <div class="tile tile--pink">
                                        <div class="tile__title">Practise your English in a fun and challenging game</div>
                                        <div class="tile__bg" style="background-image: url(img/pictures/about-01.png)"></div>
                                    </div>
                                </div>
                                <div class="swiper-slide col-md-3 col-lg-6 mb--30">
                                    <div class="tile tile--purple">
                                        <div class="tile__title">Play against friends in real time</div>
                                        <div class="tile__bg" style="background-image: url(img/pictures/about-02.png)"></div>
                                    </div>
                                </div>
                                <div class="swiper-slide col-md-3 col-lg-6 mb--30 pull-lg-top">
                                    <div class="tile tile--red">
                                        <div class="tile__title">Group, random and single-player modes</div>
                                        <div class="tile__bg" style="background-image: url(img/pictures/about-03.png)"></div>
                                    </div>
                                </div>
                                <div class="swiper-slide col-md-3 col-lg-6 mb--30">
                                    <div class="tile tile--blue">
                                        <div class="tile__title">Stay home, play safe</div>
                                        <div class="tile__bg" style="background-image: url(img/pictures/about-04.png)"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section id="individuals" class="section bg--wave bg--wave-2">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-12 col-md-6 order-md-2">
                        <div class="mr-xl--50">
                            <h2 class="title-section" data-animate="fadeInUp">
                                <span class="d--block title-primary mb--sm"><span class="c--gradient-primary">Quiz42</span></span>
                                For individuals
                            </h2>

                            <div class="opacity--sm mb--xl" data-animate="fadeInUp">
                                <p>Practise in single player mode or play against friends or random opponents in multiplayer.
                                    Earn rewards by completing achievements.</p>

                                <ul class="list--square mb--xl">
                                    <li>50:50 and blackout powerups</li>
                                    <li>achievements and badges</li>
                                    <li>chat with friends</li>
                                </ul>
                            </div>

                            <p class="mb--xl" data-animate="fadeInUp">
                                <a href="/login" class="btn btn--md2 btn--primary miw--130">Play now</a>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 order-md-1" data-animate="fadeInUp">
                        <figure class="mr-xl--80 mb--0">
                            <img src="img/pictures/pic-1.png" alt="" />
                        </figure>
                    </div>
                </div>
            </div>
        </section>

        <section id="teachers" class="section bg--wave bg--wave-3">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-12 col-md-6">
                        <div class="mr-xl--80">
                            <h2 class="title-section" data-animate="fadeInUp">
                                <span class="d--block title-primary mb--sm"><span class="c--gradient-primary">Quiz42</span></span>
                                For teachers
                            </h2>

                            <div class="opacity--sm mb--xl" data-animate="fadeInUp">
                                <p>Create a group, invite all the members of the class, then watch them playing against
                                    each other, or join in the fun yourself.</p>

                                <ul class="list--square mb--xl">
                                    <li>set the level and topic</li>
                                    <li>practise grammar</li>
                                    <li>play against other schools</li>
                                </ul>
                            </div>

                            <p class="mb--xl" data-animate="fadeInUp">
                                <a href="/login" class="btn btn--md2 btn--primary miw--130">Play now</a>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6" data-animate="fadeInUp">
                        <figure class="mr-xl--50 mb--0">
                            <img src="img/pictures/pic-2.png" alt="" />
                        </figure>
                    </div>
                </div>
            </div>
        </section>

        <section id="students" class="section bg--wave bg--wave-4">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-12 col-md-6 order-md-2">
                        <div class="mr-xl--50">
                            <h2 class="title-section" data-animate="fadeInUp">
                                <span class="d--block title-primary mb--sm"><span class="c--gradient-primary">Quiz42</span></span>
                                For students
                            </h2>

                            <div class="opacity--sm mb--xl" data-animate="fadeInUp">
                                <p>Quiz42 is like learning, only much more fun. Practise your English while playing a
                                    fun and exciting quiz game.</p>

                                <ul class="list--square mb--xl">
                                    <li>play against classmates</li>
                                    <li>Quiz42 tournaments</li>
                                    <li>check your mistakes</li>
                                </ul>
                            </div>

                            <p class="mb--xl" data-animate="fadeInUp">
                                <a href="/login" class="btn btn--md2 btn--primary miw--130">Play now</a>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 order-md-1" data-animate="fadeInUp">
                        <figure class="mr-xl--80 mb--0">
                            <img src="img/pictures/pic-3.png" alt="" />
                        </figure>
                    </div>
                </div>
            </div>
        </section>

        <section id="groups" class="section bg--gradient-transparent-red pt-xl--0">
            <div class="container">
                <div class="row align-items--center">
                    <div class="col-12 col-md-6">
                        <div class="mr-xl--80">
                            <h2 class="title-section" data-animate="fadeInUp">
                                <span class="d--block title-primary mb--sm"><span class="c--gradient-primary">Quiz42</span></span>
                                For groups
                            </h2>

                            <div class="opacity--sm mb--xl" data-animate="fadeInUp">
                                <p>Create groups and play against friends, colleagues, classmates etc. Set the level, the
                                    type of questions and the length of the game.</p>

                                <ul class="list--square mb--xl">
                                    <li>see scores on a leaderboard</li>
                                    <li>organise mini tournaments</li>
                                    <li>grow your network</li>
                                </ul>
                            </div>

                            <p class="mb--xl" data-animate="fadeInUp">
                                <a href="/login" class="btn btn--md2 btn--primary miw--130">Play now</a>
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-md-6" data-animate="fadeInUp">
                        <figure class="mr-xl--50 ml-xl--50 mb--0">
                            <img src="img/pictures/pic-4.png" alt="" />
                        </figure>
                    </div>
                </div>
            </div>
        </section>

        <footer class="footer">
            <div class="container d-lg--none">
                <ul class="footer__menu mb--30">
                    <li><router-link to="/article/privacy-policy">Privacy Policy</router-link></li>
                    <li><router-link to="/article/terms-of-service">Terms of Service</router-link></li>
                    <li><a href="mailto:info@quiz42.com">Send feedback</a></li>
                </ul>
            </div>

            <div class="copyright">
                <div class="container">
                    <div class="row align-items--center">
                        <div class="col-6 col-lg-3">
                            <p class="mb--0">&copy; 2021 - Quiz42.com</p>
                        </div>

                        <div class="col-6 col-lg-9 d--flex align-items--center justify-content--end">
                            <ul class="footer__menu d--none d-lg--flex mb--0">
                                <li><router-link to="/article/privacy-policy">Privacy Policy</router-link></li>
                                <li><router-link to="/article/terms-of-service">Terms of Service</router-link></li>
                                <li><a href="mailto:info@quiz42.com">Send feedback</a></li>
                            </ul>

                            <a href="https://www.hellooo.hu/" target="_blank" class="footer__author">
                                <img src="img/logo-hellooo.png" alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "DashboardGuest",

        created() {
            this.$nextTick(function () {
                jQuery('[data-animate]').each(function() {
                    var $this		= jQuery(this),
                        classAdd	= ($this.data('animate') === '') ? 'fadeIn' : $this.data('animate');

                    $this.addClass('scrollAnimation').viewportChecker({
                        classToAdd: classAdd,
                        offset: 100
                    });
                });

                jQuery('[data-scroll-to]').on('click', function (e) {
                    e.preventDefault();

                    var $anchor = $(this),
                        section = $($anchor.attr('href'));

                    if (section.length) {
                        e.preventDefault();

                        $('html, body').stop().animate({
                            scrollTop: $($anchor.attr('href')).offset().top
                        }, 300);
                    }
                });
            })
        }
    }
</script>
